import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectConfigValue } from '../../selectors/config';
import { selectLocationIds } from '../../selectors/offer';
import { Device } from '../common/Device';
import { HAS_BEEN_CLOSED_MARK } from './constants';
import { N1PublicationBannerDesktop, N1PublicationBannerMobile } from './components';

export const N1PublicationBannerContainer = () => {
  const locations = useSelector(selectLocationIds);
  const n1PublicationBannerLocations = useSelector(selectConfigValue('n1PublicationBannerLocations'));

  const isRequiredLocation = n1PublicationBannerLocations.some(location => locations.includes(location));

  const [isClosed, setIsClosed] = React.useState(() => {
    const isClosed = typeof sessionStorage === 'undefined' ? false : !!sessionStorage.getItem(HAS_BEEN_CLOSED_MARK);

    return isClosed;
  });

  const isVisible = isRequiredLocation && !isClosed;

  const handleCloseClick = React.useCallback(() => {
    sessionStorage.setItem(HAS_BEEN_CLOSED_MARK, '1');
    setIsClosed(true);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <Device
      desktop={<N1PublicationBannerDesktop handleCloseClick={handleCloseClick} />}
      mobile={<N1PublicationBannerMobile handleCloseClick={handleCloseClick} />}
    />
  );
};
